import apiClient from "./api";

class ExecutionNoticeService {
  // Générer un avis d'exécution
  async generateExecutionNotice(domainId, transactionId) {
    try {
      const response = await apiClient.post(`/api/domains/${domainId}/executionnotices/generate/${transactionId}`);
      return response.data;
    } catch (error) {
      // console.error('Error generating execution notice:', error);
      throw error.response?.data || { success: false, message: 'Erreur lors de la génération de l\'avis' };
    }
  }

  // Récupérer les avis d'un client
  async getClientExecutionNotices(domainId, accountId) {
    try {
      const response = await apiClient.get(`/api/domains/${domainId}/executionnotices/client/${accountId}`);
      return response.data;
    } catch (error) {
      // console.error('Error getting client execution notices:', error);
      throw error.response?.data || { success: false, message: 'Erreur lors de la récupération des avis' };
    }
  }

  // Télécharger un avis d'exécution
  async downloadExecutionNotice(domainId, noticeId) {
    try {
      const response = await apiClient.get(`/api/domains/${domainId}/executionnotices/${noticeId}/download`, {
        responseType: 'blob'
      });
      return response.data;
    } catch (error) {
      // console.error('Error downloading execution notice:', error);
      throw error.response?.data || { success: false, message: 'Erreur lors du téléchargement' };
    }
  }

  // Obtenir l'URL de visualisation
  async getExecutionNoticeViewUrl(domainId, noticeId) {
    try {
      const response = await apiClient.get(`/api/domains/${domainId}/executionnotices/${noticeId}/view-url`);
      return response.data;
    } catch (error) {
      // console.error('Error getting view URL:', error);
      throw error.response?.data || { success: false, message: 'Erreur lors de la récupération de l\'URL' };
    }
  }

  // Envoyer l'avis par email
  async sendExecutionNoticeByEmail(domainId, noticeId) {
    try {
      const response = await apiClient.post(`/api/domains/${domainId}/executionnotices/${noticeId}/send-email`);
      return response.data;
    } catch (error) {
      // console.error('Error sending execution notice by email:', error);
      throw error.response?.data || { success: false, message: 'Erreur lors de l\'envoi de l\'email' };
    }
  }

  // Marquer comme vu
  async markExecutionNoticeAsViewed(domainId, noticeId) {
    try {
      const response = await apiClient.post(`/api/domains/${domainId}/executionnotices/${noticeId}/mark-viewed`);
      return response.data;
    } catch (error) {
      // console.error('Error marking notice as viewed:', error);
      throw error.response?.data || { success: false, message: 'Erreur lors du marquage comme vu' };
    }
  }

  // Récupérer tous les avis du domain
  async getDomainExecutionNotices(domainId, page = 1, pageSize = 50) {
    try {
      const response = await apiClient.get(`/api/domains/${domainId}/executionnotices`, {
        params: { page, pageSize }
      });
      return response.data;
    } catch (error) {
      // console.error('Error getting domain execution notices:', error);
      throw error.response?.data || { success: false, message: 'Erreur lors de la récupération des avis' };
    }
  }

  // Tester le stockage blob
  async testBlobStorage(domainId, noticeId) {
    try {
      const response = await apiClient.get(`/api/domains/${domainId}/executionnotices/${noticeId}/test-blob`);
      return response.data;
    } catch (error) {
      // console.error('Error testing blob storage:', error);
      throw error.response?.data || { success: false, message: 'Erreur lors du test du stockage' };
    }
  }
}

export default new ExecutionNoticeService();